import axios from 'axios'
import Constants from '../constants'
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo');

export default {
  searchRoute: (params, lang) => {
    const { from, to, time, searchType } = params
    const options = getOptions(params, lang)

    return new Promise((resolve, reject) => {
      axios.get('searchCourse', { params: options })
        .then(payload => {
          const result = payload.data.ResultSet
          if (result.Course) {
            const index = to.index === undefined ? from.index + 1 : to.index
            const points = parseRoutes(
              from,
              to,
              result.Course[0].Route.Point.concat(),
              result.Course[0].Route.Line.concat()
            )

            // NOTE: 変数名がわかりにくくなってしまっているのですが、departureTimeは前の予定(from)の終了時刻、
            //   arrivalTimeは次の予定(to)の開始時刻になります
            const departureTime = searchType == 'departure' ? time : points[0].departureTime
            const arrivalTime = searchType == 'arrival' ? time : points.slice(-1)[0].arrivalTime
            
            const searchDatetime = moment(options.date.substring(0, 4) + "-" + options.date.substring(4, 6) + "-" + options.date.substring(6, 8) + " " + options.time.substring(0, 2) + ":" + options.date.substring(2, 4))

            resolve({
              index: index,
              course: result.Course[0],
              points: points,
              departureTime: departureTime,
              arrivalTime: arrivalTime,
              serializeData: result.Course[0].SerializeData,
              viaList: options.viaList,
              searchType: options.searchType,
              searchDatetime: searchDatetime
            })
          } else {
            reject()
          }
        })
        .catch (error => {
          reject(error)
        })
    })
  },
  searchRouteAll: (params, lang) => {
    const { from, to, time, searchType } = params
    const options = getOptions(params, lang)

    return new Promise((resolve, reject) => {
      axios.get('searchCourse', { params: options })
        .then(payload => {
          const result = payload.data.ResultSet
          if (result.Course) {
            let courses = []
            for (let i = 0; i < result.Course.length; i++) {
              const points = parseRoutes(
                from,
                to,
                result.Course[i].Route.Point.concat(),
                result.Course[i].Route.Line.concat()
              )

              // NOTE: 変数名がわかりにくくなってしまっているのですが、departureTimeは前の予定(from)の終了時刻、
              //   arrivalTimeは次の予定(to)の開始時刻になります
              const departureTime = searchType == 'departure' ? time : points[0].departureTime
              const arrivalTime = searchType == 'arrival' ? time : points.slice(-1)[0].arrivalTime

              courses.push({
                index: i,
                course: result.Course[i],
                points: points,
                departureTime: departureTime,
                arrivalTime: arrivalTime,
                serializeData: result.Course[i].SerializeData
              })
            }
            resolve(courses)
          } else {
            reject()
          }
        })
        .catch (error => {
          reject(error)
        })
    })
  },
  recommendSearchCourse: ({ fromLocation, toLocation }) => {
    const now = moment()
    const f = Object.values(fromLocation).join(',')
    const t = Object.values(toLocation).join(',')
    const params = {
      id: Constants.API_ID,
      key: Constants.API_KEY,
      date: now.format('YYYYMMDD'),
      time: now.format('HHmm'),
      viaList: [f, t].join(':')
    }

    return new Promise((resolve) => {
      axios.get('recommendSearchCourse', { params })
        .then(payload => {
          const result = payload.data.ResultSet
          if (result.totalTime) {
            resolve(result.totalTime)
          }
        })
    })
  }
}

function getOptions(params, lang) {
  const { searchType, time, from, to, taxiDistance, sort } = params
  let options = {
    id: Constants.API_ID,
    key: Constants.API_KEY,
    searchType: searchType,
    date: time.format('YYYYMMDD'),
    time: time.format('HHmm'),
    answerCount: (params.answerCount ? 1 : params.answerCount),
    viaList: [getPoint(from), getPoint(to)].join(":"),
    sort: sort,
    language: lang,
    serializeData: params.serializeData
  }

  if (taxiDistance > 0) {
    options = Object.assign(options, { maxCarDistance: 30000 })
    options = Object.assign(options, { maxWalkDistance: String(taxiDistance) })
  } else {
    options = Object.assign(options, { maxCarDistance: 0 })
    options = Object.assign(options, { maxWalkDistance: 3000 })
  }

  // TODO: 条件を確認する
  if (from && to && (from.isStation || to.isStation)) {
    options = Object.assign(options, { conditionDetail: 'T3221233232319:F232112112300:A23121141:' })
  } else {
    options = Object.assign(options, { conditionDetail: 'T1111233232319:F232112112300:A23121141:' })
  }

  return options
}

function getPoint(destination) {
  if (destination.isStation) {
    return destination.code
  } else {
    return destination.location.latitude + "," + destination.location.longitude
  }
}

function parseRoutes(from, to, points, lines) {
  const first = points.shift()
  const last = points.pop()

  return [
    parseDeparture(from, first, lines[0]),
    ...parsePoints(points, lines),
    parseArrival(to, last, lines[lines.length - 1])
  ]
}

function parseDeparture(from, point, line) {
  const name = point.Station ? point.Station.Name : from.name

  return {
    name: name,
    departureTime: moment(line.DepartureState.Datetime.text),
    line: parseLine(line),
    ...parseLocation(point)
  }
}

function parseArrival(to, point, line) {
  const name = point.Station ? point.Station.Name : to.name

  return {
    name: name,
    arrivalTime: moment(line.ArrivalState.Datetime.text),
    ...parseLocation(point)
  }
}

function parsePoints(points, lines) {
  return points.map((point, index) => {
    return {
      name: point.Station.Name,
      arrivalTime: moment(lines[index].ArrivalState.Datetime.text),
      departureTime: moment(lines[index + 1].DepartureState.Datetime.text),
      pole: getPoleSendaiSta(point, lines[index + 1]),
      line: parseLine(lines[index + 1]),
      ...parseLocation(point),
    }
  })
}

function parseLine(line) {
  return {
    name: line.Name,
    color: line.Color,
    type: getTextValue(line.Type),
    duration: line.timeOnBoard
  }
}

function getTextValue(obj) {
  return (obj === undefined ? "" : (obj.text !== undefined ? obj.text : obj));
}

function parseLocation(point) {
  return {
    location: {
      latitude: parseFloat(point.GeoPoint.lati_d),
      longitude: parseFloat(point.GeoPoint.longi_d)
    }
  }
}

function getPoleSendaiSta(point, line) {
  let pole_no
  if ((point.Station.Name == "仙台駅前／仙台市営バス") && (line.DepartureState.no)) {
    pole_no = line.DepartureState.no
  } else if (point.Station.Name == "仙台駅前／仙台市") {
    // るーぷるは16番のりば固定
    pole_no = "16"
  }
  const pole = Constants.SENDAI_STA_POLE.find((s) => s.no == pole_no)
  return pole
}
